import { TableCell, TableRow } from "@material-ui/core";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import MuiButton from "@mui/material/Button";
import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import messages from "../../../assets/locale/messages";
import Button from "../../../components/Button";
import Table from "../../../components/Table";
import { assignUsersFromFileToProgram } from "../../../store/Programs/actions";
import { showHideSnackbar } from "../../../store/Snackbar/actions";

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
const requiredHeaders = [
  "country_id",
  "email",
  "first_name",
  "second_name"
];
const usersFromFileHeadersUI = [
  "country id",
  "email",
  "first name",
  "second name"
];
function AssignUsers({ id }) {
  const lang = useSelector((state) => state.locale.lang);
  const dispatch = useDispatch();
  const {
    programs: { assignUsers, uploadStudentsError },
    shared: { assign, upload }
  } = messages[lang];

  const uploadRef = useRef(null);
  const [file, setFile] = useState(null);
  const handleDirectorSubmit = () => {
    if (!file) {
      dispatch(
        showHideSnackbar({
          isOpen: true,
          message: uploadStudentsError,
          type: "error"
        })
      );
      return;
    }

    const formData = new FormData();

    formData.append("program[users_file]", file);
    dispatch(
      assignUsersFromFileToProgram({
        id,
        data: formData
      })
    );

    // Clear the input
    deleteFile();
  };

  const [usersFromFile, setUsersFromFile] = useState([]);
  function deleteFile() {
    uploadRef.current.value = null;
    setFile(null);
    setUsersFromFile([]);
  }
  const readXLSX = (e) => {
    try {
      const f = e.target.files[0];
      //type file Check
      const isCSV =
        f.type === "text/csv" ||
        f.name.toLowerCase().endsWith(".csv");
      if (!isCSV) {
        deleteFile();
        return dispatch(
          showHideSnackbar({
            isOpen: true,
            message: "Only CSV files are allowed.",
            type: "error"
          })
        );
      }
      //size file Check
      if (f.size > MAX_FILE_SIZE) {
        dispatch(
          showHideSnackbar({
            isOpen: true,
            message: "File size must be less than 5MB",
            type: "error"
          })
        );
        deleteFile();
        return;
      }

      setFile(f);
      var reader = new FileReader();
      reader.onload = function (e) {
        const workbook = XLSX.read(e.target.result, {
          type: "binary"
        });
        const sheetNameList = workbook.SheetNames;
        const jsonData = XLSX.utils.sheet_to_json(
          workbook.Sheets[sheetNameList[0]]
        );
        //empty file Check
        if (!jsonData.length) {
          return dispatch(
            showHideSnackbar({
              isOpen: true,
              message: "The uploaded CSV file is empty",
              type: "error"
            })
          );
        }
        const fileHeader = Object.keys(jsonData[0]);
        // Header Check
        const missingHeaders = requiredHeaders.filter(
          (header) => !fileHeader.includes(header)
        );
        if (missingHeaders.length) {
          deleteFile();
          return dispatch(
            showHideSnackbar({
              isOpen: true,
              message: `Missing required columns: ${missingHeaders.join(
                ", "
              )}`,
              type: "error"
            })
          );
        }
        // If a row does not contain an email, the backend will not return any error
        // Rows Check
        // const isAllRowsValid = jsonData.filter(
        //   (row) =>
        //     !row.country_id ||
        //     !row.email ||
        //     !row.first_name ||
        //     !row.second_name
        // );
        // if (isAllRowsValid.length) {
        //   return dispatch(
        //     showHideSnackbar({
        //       isOpen: true,
        //       message: "Some rows have missing required fields",
        //       type: "error"
        //     })
        //   );
        // }

        // email Check
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const invalidEmails = jsonData.filter(
          (row) => !emailRegex.test(row.email)
        );

        if (invalidEmails.length) {
          deleteFile();
          dispatch(
            showHideSnackbar({
              isOpen: true,
              message: "Some rows contain invalid email addresses",
              type: "error"
            })
          );
          return;
        }

        setUsersFromFile(jsonData);
      };
      reader.readAsBinaryString(f);
      // Clear the input value to allow selecting the same file again
      uploadRef.current.value = null;
    } catch (error) {
      console.error("error", error);
      dispatch(
        showHideSnackbar({
          isOpen: true,
          message: "something is Wrong.",
          type: "error"
        })
      );
      uploadRef.current.value = null;
    }
  };

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel2-content"
        id="panel2-header"
      >
        {assignUsers}
      </AccordionSummary>
      <AccordionDetails>
        <input
          type="file"
          style={{ display: "none" }}
          ref={uploadRef}
          onChange={readXLSX}
        />
        <MuiButton
          variant="outlined"
          onClick={() => {
            if (uploadRef.current) uploadRef.current.click();
          }}
        >
          {upload}
        </MuiButton>
        {!!usersFromFile.length && (
          <Table
            headlines={usersFromFileHeadersUI}
            rows={usersFromFile.map((row) => (
              <TableRow className="table__row" key={row.email}>
                <TableCell className="table__cell" align="left">
                  {row.country_id}
                </TableCell>
                <TableCell className="table__cell" align="left">
                  {row.email}
                </TableCell>
                <TableCell className="table__cell" align="left">
                  {row.first_name}
                </TableCell>
                <TableCell className="table__cell" align="left">
                  {row.second_name}
                </TableCell>
              </TableRow>
            ))}
          />
        )}
      </AccordionDetails>
      <AccordionActions>
        <Button
          onClick={() => {
            handleDirectorSubmit();
          }}
          text={assign}
        />
      </AccordionActions>
    </Accordion>
  );
}

AssignUsers.propTypes = {
  id: PropTypes.string,
  users: PropTypes.array
};

export default AssignUsers;
